import { AxiosInstance, AxiosResponse } from "axios"

/**
 * Fetches the list of available users in a user's unit.
 *
 * @param axiosInstance - Authenticated axios instance
 * @returns The response from the API containing the list of available usernames as a newline-separated string.
 * @throws Will throw an error if the request fails.
 */
export async function fetchUnitUsers(
  axiosInstance: AxiosInstance
): Promise<AxiosResponse<string>> {
  const response = await axiosInstance.get<string>(`/available-users`)
  return response
}
